
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import kinai from "../../assets/kinai.jpg";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function KinaiMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Kínai magyar fordító</title>
                <meta name='description' content="Ingyenes kínai magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Kínai magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/kinai-magyar-fordito" />
            </Helmet>
            <h1>Kínai magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A kínai nyelvről</h2>
                    <img src={kinai} alt="Japán zászló"></img>

                </div>


                <p>A kínai a rokon nyelvek csoportja, amelyet a kínai lakosság többsége és a kínai közösségek világszerte beszélnek. Világszerte az egyik legelterjedtebb nyelv, több mint 1,3 milliárd beszélővel.</p>

                <p>A kínai nyelvcsalád hatalmas és változatos, de a legelterjedtebb beszélt változata a mandarin, amely Kína hivatalos nyelve, és a pekingi dialektuson alapul. További jelentős kínai nyelvek a kantoni, a sanghaji és a hokkien, amelyek mindegyike sajátos jellegzetességekkel rendelkezik.</p>

                <p>A kínai írásjegyek, az úgynevezett hànzì, a világ egyik legrégebbi írásrendszere. Minden karakter egy morfémát vagy jelentésegységet jelöl, és a kínai írásbeliségben több ezer karaktert használnak. A mandarin kínai nyelv a kiejtés jelölésére a latin ábécét használó pinyint, a latin betűs írásmódot is alkalmazza.</p>

                <p>Nyelvtana eltér az indoeurópai nyelvektől. Elsősorban analitikus, kevés flektálással, és nagymértékben támaszkodik a szórendre és a partikulákra a jelentés közvetítése érdekében. A mandarin kínai nyelv alany-ige-tárgy mondatszerkezetet követ, de a szigorú idő- és esetrendszerek hiánya miatt rugalmasságot tesz lehetővé.</p>

                <p>A mandarin kínai nyelvnek négy hangja van, valamint egy semleges hang, amelyek a hangmagasságtól függően különböző jelentéstartalommal ruházzák fel a szavakat. A hangok elsajátítása kulcsfontosságú a kínai nyelvben való pontos kommunikációhoz.</p>

                <p>A kínai szókincs kiterjedt és folyamatosan fejlődik. Tartalmazza mind az anyanyelvi kínai szavakat, mind a más nyelvekből, különösen az angolból és más ázsiai nyelvekből származó kölcsönszavakat. A kínai idiómák és közmondások, az úgynevezett chéngyǔ, széles körben használatosak, és a kínai nép kulturális értékeit és bölcsességét tükrözik.</p>

                <p>A nyelv tanulása hozzáférést biztosít egy több mint 5000 éves gazdag kulturális örökséghez. Megnyitja az utat a klasszikus kínai irodalom, a filozófia és a hagyományos művészetek, például a kalligráfia, a festészet és a kínai opera felé. A nyelv megértése a kínai történelembe, szokásokba és társadalmi normákba való betekintést is elmélyíti.</p>

                <p>Ismerete rendkívül értékes a mai globalizált világban. Kína gazdasági növekedése és politikai befolyása a nemzetközi ügyek jelentős szereplőjévé tette. A kínai nyelv és kultúra ismerete lehetőségeket kínál az üzleti életben, a kereskedelemben, a diplomáciában, a turizmusban és a tudományos kutatásban.</p>
        
                <div className="sectionbottom">
                    <Link to="/magyar-kinai-fordito">Magyar kínai fordító</Link>

                    <img src={kinai} alt="kínai zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
        
        
           </section>
        </>

    )
}

export default KinaiMagyar;